<template>
  <div class="allTable">
    <div class="grouptitle">
      <div class="subjtitle">ចំណងជើងសៀវភៅ</div>
      <div class="stitle"  v-for="(index) in subSec.length" :key="index">&nbsp;{{subSec[index-1]}}</div>
    </div>
    <div class="groupTable">
      <single-table :title="fTitle" :data="fData"></single-table>
      <single-table :title="sTitle" :data="sData"></single-table>
    </div>
  </div>
</template>

<script>
import apCon from '@/utils/textbookConfig.js'
import singleTable from '@/components/textbook/secondaryTable.vue'
export default {
  props: ['fTitle', 'fData', 'sTitle', 'sData'],
  components: {
    'single-table': singleTable
  },
  data () {
    return {
      subSec: apCon.sjectSec
    }
  }
}
</script>

<style scoped>
.allTable {
  display: flex;
  border:0px;
  width:720px;
}
.groupTable {
  display: flex;
  border:0px;
  width:720px;
}

.grouptitle {
  display: flex;
  flex-direction: column;
  width:360px;
  height:760px;
}
.subjtitle {
  text-align:center;
  border:1px solid #000;
  font-weight: bold;
  font-family: "khmer";
  font-size: 12px;
  width:140px;
  height:80px;
  line-height: 80px; /* make the text vertical middle*/
}
.stitle {
  text-align:left;
  border:1px solid #000;
  overflow: hidden;
  font-family: "khmer";
  font-size: 12px;
  width:140px;
  height:40px;
  line-height: 40px; /*make the text vertical middle*/
}
</style>

